import { ENV } from '../amplify-config';

/**
 * The portal-api origin a staff-mounted OBW step must call.
 *
 * ⭐⭐ WHY THIS IS SEEDED DATA RATHER THAN A GLOBAL, AND WHY ONE HELPER RATHER THAN THREE COPIES.
 *
 * ADR-076's core principle is that the journey is MOUNT-BLIND: it carries no launch context and
 * learns nothing about where it was opened from except through the data it was seeded with. The
 * launch token already works that way. The origin now has to, for a concrete reason rather than
 * a stylistic one — the staff OBW spans TWO apis, and only the first is zone-routable through
 * `adminApiInZone`. The mint (`POST /admin/{bow,sow}/launch`) is admin-api; the ACCOUNT IS
 * CREATED by `POST /portal/{bow,sow}/provision` on portal-api. A step reaching for
 * `ENV.PORTAL_API_BASE_URL` directly would send that second call to the zone this BUNDLE was
 * built for, whatever zone the journey was launched into — so a US-targeted journey would mint
 * in US and create the account in AU.
 *
 * ⚠ THE FALLBACK IS THE WHOLE PRE-EXISTING BEHAVIOUR, DELIBERATELY. An unseeded journey — the
 * subscriber-portal mount, any path that predates the zone chooser, every existing test — reads
 * exactly the build-time constant it read before. This helper can therefore only CHANGE the
 * destination of a journey that was explicitly told where it is going.
 */
export function portalOriginFor(data: Record<string, unknown> | undefined): string {
  const seeded = data?.['portalApiBase'];
  return typeof seeded === 'string' && seeded.length > 0 ? seeded : ENV.PORTAL_API_BASE_URL;
}
